import { render, staticRenderFns } from "./ContactUsModal.vue?vue&type=template&id=22ea6278&"
import script from "./ContactUsModal.vue?vue&type=script&lang=ts&"
export * from "./ContactUsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports